/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PERMISSIONS } from '@squiz/dxp-auth';
import { ICON_CHAT_UNREAD, ICON_CONTENT_PASTE_SEARCH, ICON_DASHBOARD, NavigationItem } from '@squiz/sds';
import { TENANT_FEATURE_FLAGS } from 'apps/console-core/src/Constants/FeatureFlags.constants';
import React from 'react';
import { AiChatbots } from '../Screens/AiChatbots/AiChatbots';
import { AiViewChatbot } from '../Screens/AiViewChatbot/AiViewChatbot';
import { AiViewChatbotContext } from '../Screens/AiViewChatbotContext/AiViewChatbotContext';
import { ConversationsDashboard } from '../Screens/ConversationsDashboard/ConversationsDashboard';
import { SemanticAuditor } from '../Screens/SemanticAuditor/SemanticAuditor';
import { SemanticAuditorTestBuilder } from '../Screens/SemanticAuditorTestBuilder/SemanticAuditorTestBuilder';
import { screenPaths } from './ScreenPaths.constants';
import { AI_STRINGS } from './Strings.constants';

export const CONVERSATIONS_DASHBOARD: NavigationItem = {
  featureFlag: TENANT_FEATURE_FLAGS.CONVERSATIONS_ACCESS,
  icon: ICON_DASHBOARD,
  key: `conversations`,
  label: AI_STRINGS.dashboard,
  path: screenPaths.conversationsDashboard,
  permission: PERMISSIONS.dxpAi.CHATBOT_READ,
  screen: <ConversationsDashboard />,
};

export const AI_CHATBOTS: NavigationItem = {
  featureFlag: TENANT_FEATURE_FLAGS.CHATBOTS_ACCESS,
  icon: ICON_CHAT_UNREAD,
  key: `ai-chatbots`,
  label: AI_STRINGS.aiChatbots,
  path: screenPaths.aiChatbots,
  permission: PERMISSIONS.dxpAi.CHATBOT_READ,
  screen: <AiChatbots />,
};

export const VIEW_AI_CHATBOT: NavigationItem = {
  devices: [],
  featureFlag: TENANT_FEATURE_FLAGS.CHATBOTS_ACCESS,
  key: `view-ai-chatbot`,
  label: AI_STRINGS.viewChatbot,
  path: screenPaths.viewAiChatbot,
  permission: PERMISSIONS.dxpAi.CHATBOT_READ,
  screen: <AiViewChatbot />,
};

export const VIEW_AI_CHATBOT_CONTEXT: NavigationItem = {
  devices: [],
  featureFlag: TENANT_FEATURE_FLAGS.CHATBOTS_ACCESS,
  key: `view-ai-chatbot-context`,
  label: AI_STRINGS.viewChatbotContext,
  path: screenPaths.viewAiChatbotContext,
  permission: PERMISSIONS.dxpAi.CONTEXT_INSTANCE_READ,
  screen: <AiViewChatbotContext />,
};

export const SEMANTIC_AUDITOR_TEST_BUILDER: NavigationItem = {
  devices: [],
  featureFlag: TENANT_FEATURE_FLAGS.CHATBOTS_ACCESS,
  key: 'Semantic auditor test builder',
  label: AI_STRINGS.semanticAuditorTestBuilder,
  path: screenPaths.semanticAuditorTestBuilder,
  screen: <SemanticAuditorTestBuilder />,
};

export const SEMANTIC_AUDITOR: NavigationItem = {
  featureFlag: TENANT_FEATURE_FLAGS.CHATBOTS_ACCESS,
  icon: ICON_CONTENT_PASTE_SEARCH,
  key: `semantic-auditor`,
  label: AI_STRINGS.semanticAuditor,
  linkedScreens: [SEMANTIC_AUDITOR_TEST_BUILDER],
  path: screenPaths.semanticAuditor,
  permission: PERMISSIONS.dxpAi.CHATBOT_READ,
  screen: <SemanticAuditor />,
};
